export enum WhatsappTemplate {
  GenericAppDownload = 'generic_app_download',
  AbhaAppDownload = 'abha_app_download',
  ChallanAppDownload = 'challan_app_download',
  AssetsAppDownload = 'assets_app_download',
  AmbulanceAppDownload = 'ambulance_app_download',
  VisaAppDownload = 'visa_app_download',
  CouponsAppDownload = 'coupons_app_download',
}
